'use strict';

require("core-js/modules/es6.regexp.replace");

module.exports = collapse; // `collapse(' \t\nbar \nbaz\t') // ' bar baz '`

function collapse(value) {
  return String(value).replace(/\s+/g, ' ');
}